/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  StripeAppAuthorizeResponse,
  StripeAppConnectBody,
  StripeAppConnection,
  StripeAppCreateInvoiceBody,
  StripeAppDisconnect200,
  StripeAppEntityDisconnect200,
  StripeAppEntityUpdateSettingsBody,
  StripeAppInvoice,
  StripeAppInvoiceList,
  StripeAppListInvoicesParams,
  StripeAppLookupInvoiceParams,
  StripeAppMarketplaceAuthorizeBody,
  StripeAppOAuthCallbackParams,
  StripeAppSettings,
  StripeAppUpdateSettingsBody,
  StripeAppWebhookResponse,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Generate a state token and redirect URL for the Apollo onboarding flow.
 * @summary Start Stripe App connection
 */
export type stripeAppAuthorizeResponse200 = {
  data: StripeAppAuthorizeResponse
  status: 200
}

export type stripeAppAuthorizeResponse400 = {
  data: Error
  status: 400
}

export type stripeAppAuthorizeResponse401 = {
  data: Error
  status: 401
}

export type stripeAppAuthorizeResponse403 = {
  data: Error
  status: 403
}

export type stripeAppAuthorizeResponse404 = {
  data: Error
  status: 404
}

export type stripeAppAuthorizeResponse500 = {
  data: Error
  status: 500
}

export type stripeAppAuthorizeResponseSuccess = (stripeAppAuthorizeResponse200) & {
  headers: Headers;
};
export type stripeAppAuthorizeResponseError = (stripeAppAuthorizeResponse400 | stripeAppAuthorizeResponse401 | stripeAppAuthorizeResponse403 | stripeAppAuthorizeResponse404 | stripeAppAuthorizeResponse500) & {
  headers: Headers;
};

export type stripeAppAuthorizeResponse = (stripeAppAuthorizeResponseSuccess | stripeAppAuthorizeResponseError)

export const getStripeAppAuthorizeUrl = () => {


  

  return `/stripe-app/authorize`
}

export const stripeAppAuthorize = async ( options?: RequestInit): Promise<stripeAppAuthorizeResponse> => {
  
  return customFetch<stripeAppAuthorizeResponse>(getStripeAppAuthorizeUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Handles the OAuth callback from Stripe. Exchanges the authorization code for tokens and redirects to Apollo frontend.
 * @summary OAuth callback from Stripe
 */
export type stripeAppOAuthCallbackResponse302 = {
  data: void
  status: 302
}

export type stripeAppOAuthCallbackResponse400 = {
  data: Error
  status: 400
}

export type stripeAppOAuthCallbackResponse401 = {
  data: Error
  status: 401
}

export type stripeAppOAuthCallbackResponse403 = {
  data: Error
  status: 403
}

export type stripeAppOAuthCallbackResponse404 = {
  data: Error
  status: 404
}

export type stripeAppOAuthCallbackResponse500 = {
  data: Error
  status: 500
}

;
export type stripeAppOAuthCallbackResponseError = (stripeAppOAuthCallbackResponse302 | stripeAppOAuthCallbackResponse400 | stripeAppOAuthCallbackResponse401 | stripeAppOAuthCallbackResponse403 | stripeAppOAuthCallbackResponse404 | stripeAppOAuthCallbackResponse500) & {
  headers: Headers;
};

export type stripeAppOAuthCallbackResponse = (stripeAppOAuthCallbackResponseError)

export const getStripeAppOAuthCallbackUrl = (params: StripeAppOAuthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/stripe-app/oauth/callback?${stringifiedParams}` : `/stripe-app/oauth/callback`
}

export const stripeAppOAuthCallback = async (params: StripeAppOAuthCallbackParams, options?: RequestInit): Promise<stripeAppOAuthCallbackResponse> => {
  
  return customFetch<stripeAppOAuthCallbackResponse>(getStripeAppOAuthCallbackUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Receive and process Stripe webhook events for auto-invoice creation.
 * @summary Handle Stripe App webhook
 */
export type stripeAppWebhookResponse200 = {
  data: StripeAppWebhookResponse
  status: 200
}

export type stripeAppWebhookResponse400 = {
  data: Error
  status: 400
}

export type stripeAppWebhookResponse401 = {
  data: Error
  status: 401
}

export type stripeAppWebhookResponse403 = {
  data: Error
  status: 403
}

export type stripeAppWebhookResponse404 = {
  data: Error
  status: 404
}

export type stripeAppWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppWebhookResponse500 = {
  data: Error
  status: 500
}

export type stripeAppWebhookResponseSuccess = (stripeAppWebhookResponse200) & {
  headers: Headers;
};
export type stripeAppWebhookResponseError = (stripeAppWebhookResponse400 | stripeAppWebhookResponse401 | stripeAppWebhookResponse403 | stripeAppWebhookResponse404 | stripeAppWebhookResponse422 | stripeAppWebhookResponse500) & {
  headers: Headers;
};

export type stripeAppWebhookResponse = (stripeAppWebhookResponseSuccess | stripeAppWebhookResponseError)

export const getStripeAppWebhookUrl = () => {


  

  return `/stripe-app/webhooks`
}

export const stripeAppWebhook = async ( options?: RequestInit): Promise<stripeAppWebhookResponse> => {
  
  return customFetch<stripeAppWebhookResponse>(getStripeAppWebhookUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Initiate the Stripe OAuth flow from the Apollo web app. Returns a Stripe OAuth URL that the frontend should redirect the user to.
 * @summary Start marketplace OAuth flow
 */
export type stripeAppMarketplaceAuthorizeResponse200 = {
  data: StripeAppAuthorizeResponse
  status: 200
}

export type stripeAppMarketplaceAuthorizeResponse400 = {
  data: Error
  status: 400
}

export type stripeAppMarketplaceAuthorizeResponse401 = {
  data: Error
  status: 401
}

export type stripeAppMarketplaceAuthorizeResponse403 = {
  data: Error
  status: 403
}

export type stripeAppMarketplaceAuthorizeResponse404 = {
  data: Error
  status: 404
}

export type stripeAppMarketplaceAuthorizeResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppMarketplaceAuthorizeResponse500 = {
  data: Error
  status: 500
}

export type stripeAppMarketplaceAuthorizeResponseSuccess = (stripeAppMarketplaceAuthorizeResponse200) & {
  headers: Headers;
};
export type stripeAppMarketplaceAuthorizeResponseError = (stripeAppMarketplaceAuthorizeResponse400 | stripeAppMarketplaceAuthorizeResponse401 | stripeAppMarketplaceAuthorizeResponse403 | stripeAppMarketplaceAuthorizeResponse404 | stripeAppMarketplaceAuthorizeResponse422 | stripeAppMarketplaceAuthorizeResponse500) & {
  headers: Headers;
};

export type stripeAppMarketplaceAuthorizeResponse = (stripeAppMarketplaceAuthorizeResponseSuccess | stripeAppMarketplaceAuthorizeResponseError)

export const getStripeAppMarketplaceAuthorizeUrl = () => {


  

  return `/stripe-app/marketplace-authorize`
}

export const stripeAppMarketplaceAuthorize = async (stripeAppMarketplaceAuthorizeBody: StripeAppMarketplaceAuthorizeBody, options?: RequestInit): Promise<stripeAppMarketplaceAuthorizeResponse> => {
  
  return customFetch<stripeAppMarketplaceAuthorizeResponse>(getStripeAppMarketplaceAuthorizeUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stripeAppMarketplaceAuthorizeBody,)
  }
);}
  

/**
 * Complete the connection between a Stripe account and a Space Invoices entity. Requires bearer authentication (user must be signed in to Apollo).
 * @summary Complete Stripe App connection
 */
export type stripeAppConnectResponse201 = {
  data: StripeAppConnection
  status: 201
}

export type stripeAppConnectResponse400 = {
  data: Error
  status: 400
}

export type stripeAppConnectResponse401 = {
  data: Error
  status: 401
}

export type stripeAppConnectResponse403 = {
  data: Error
  status: 403
}

export type stripeAppConnectResponse404 = {
  data: Error
  status: 404
}

export type stripeAppConnectResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppConnectResponse500 = {
  data: Error
  status: 500
}

export type stripeAppConnectResponseSuccess = (stripeAppConnectResponse201) & {
  headers: Headers;
};
export type stripeAppConnectResponseError = (stripeAppConnectResponse400 | stripeAppConnectResponse401 | stripeAppConnectResponse403 | stripeAppConnectResponse404 | stripeAppConnectResponse422 | stripeAppConnectResponse500) & {
  headers: Headers;
};

export type stripeAppConnectResponse = (stripeAppConnectResponseSuccess | stripeAppConnectResponseError)

export const getStripeAppConnectUrl = () => {


  

  return `/stripe-app/connect`
}

export const stripeAppConnect = async (stripeAppConnectBody: StripeAppConnectBody, options?: RequestInit): Promise<stripeAppConnectResponse> => {
  
  return customFetch<stripeAppConnectResponse>(getStripeAppConnectUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stripeAppConnectBody,)
  }
);}
  

/**
 * Get the current Stripe App connection status and configuration.
 * @summary Get connection status
 */
export type stripeAppGetConnectionResponse200 = {
  data: StripeAppConnection
  status: 200
}

export type stripeAppGetConnectionResponse400 = {
  data: Error
  status: 400
}

export type stripeAppGetConnectionResponse401 = {
  data: Error
  status: 401
}

export type stripeAppGetConnectionResponse403 = {
  data: Error
  status: 403
}

export type stripeAppGetConnectionResponse404 = {
  data: Error
  status: 404
}

export type stripeAppGetConnectionResponse500 = {
  data: Error
  status: 500
}

export type stripeAppGetConnectionResponseSuccess = (stripeAppGetConnectionResponse200) & {
  headers: Headers;
};
export type stripeAppGetConnectionResponseError = (stripeAppGetConnectionResponse400 | stripeAppGetConnectionResponse401 | stripeAppGetConnectionResponse403 | stripeAppGetConnectionResponse404 | stripeAppGetConnectionResponse500) & {
  headers: Headers;
};

export type stripeAppGetConnectionResponse = (stripeAppGetConnectionResponseSuccess | stripeAppGetConnectionResponseError)

export const getStripeAppGetConnectionUrl = () => {


  

  return `/stripe-app/connection`
}

export const stripeAppGetConnection = async ( options?: RequestInit): Promise<stripeAppGetConnectionResponse> => {
  
  return customFetch<stripeAppGetConnectionResponse>(getStripeAppGetConnectionUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Remove the connection between Stripe and Space Invoices. Deletes the stored API key.
 * @summary Disconnect Stripe App
 */
export type stripeAppDisconnectResponse200 = {
  data: StripeAppDisconnect200
  status: 200
}

export type stripeAppDisconnectResponse400 = {
  data: Error
  status: 400
}

export type stripeAppDisconnectResponse401 = {
  data: Error
  status: 401
}

export type stripeAppDisconnectResponse403 = {
  data: Error
  status: 403
}

export type stripeAppDisconnectResponse404 = {
  data: Error
  status: 404
}

export type stripeAppDisconnectResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppDisconnectResponse500 = {
  data: Error
  status: 500
}

export type stripeAppDisconnectResponseSuccess = (stripeAppDisconnectResponse200) & {
  headers: Headers;
};
export type stripeAppDisconnectResponseError = (stripeAppDisconnectResponse400 | stripeAppDisconnectResponse401 | stripeAppDisconnectResponse403 | stripeAppDisconnectResponse404 | stripeAppDisconnectResponse422 | stripeAppDisconnectResponse500) & {
  headers: Headers;
};

export type stripeAppDisconnectResponse = (stripeAppDisconnectResponseSuccess | stripeAppDisconnectResponseError)

export const getStripeAppDisconnectUrl = () => {


  

  return `/stripe-app/connection`
}

export const stripeAppDisconnect = async ( options?: RequestInit): Promise<stripeAppDisconnectResponse> => {
  
  return customFetch<stripeAppDisconnectResponse>(getStripeAppDisconnectUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Get the auto-invoice configuration for this connection.
 * @summary Get auto-invoice settings
 */
export type stripeAppGetSettingsResponse200 = {
  data: StripeAppSettings
  status: 200
}

export type stripeAppGetSettingsResponse400 = {
  data: Error
  status: 400
}

export type stripeAppGetSettingsResponse401 = {
  data: Error
  status: 401
}

export type stripeAppGetSettingsResponse403 = {
  data: Error
  status: 403
}

export type stripeAppGetSettingsResponse404 = {
  data: Error
  status: 404
}

export type stripeAppGetSettingsResponse500 = {
  data: Error
  status: 500
}

export type stripeAppGetSettingsResponseSuccess = (stripeAppGetSettingsResponse200) & {
  headers: Headers;
};
export type stripeAppGetSettingsResponseError = (stripeAppGetSettingsResponse400 | stripeAppGetSettingsResponse401 | stripeAppGetSettingsResponse403 | stripeAppGetSettingsResponse404 | stripeAppGetSettingsResponse500) & {
  headers: Headers;
};

export type stripeAppGetSettingsResponse = (stripeAppGetSettingsResponseSuccess | stripeAppGetSettingsResponseError)

export const getStripeAppGetSettingsUrl = () => {


  

  return `/stripe-app/settings`
}

export const stripeAppGetSettings = async ( options?: RequestInit): Promise<stripeAppGetSettingsResponse> => {
  
  return customFetch<stripeAppGetSettingsResponse>(getStripeAppGetSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update the auto-invoice configuration for this connection.
 * @summary Update auto-invoice settings
 */
export type stripeAppUpdateSettingsResponse200 = {
  data: StripeAppSettings
  status: 200
}

export type stripeAppUpdateSettingsResponse400 = {
  data: Error
  status: 400
}

export type stripeAppUpdateSettingsResponse401 = {
  data: Error
  status: 401
}

export type stripeAppUpdateSettingsResponse403 = {
  data: Error
  status: 403
}

export type stripeAppUpdateSettingsResponse404 = {
  data: Error
  status: 404
}

export type stripeAppUpdateSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppUpdateSettingsResponse500 = {
  data: Error
  status: 500
}

export type stripeAppUpdateSettingsResponseSuccess = (stripeAppUpdateSettingsResponse200) & {
  headers: Headers;
};
export type stripeAppUpdateSettingsResponseError = (stripeAppUpdateSettingsResponse400 | stripeAppUpdateSettingsResponse401 | stripeAppUpdateSettingsResponse403 | stripeAppUpdateSettingsResponse404 | stripeAppUpdateSettingsResponse422 | stripeAppUpdateSettingsResponse500) & {
  headers: Headers;
};

export type stripeAppUpdateSettingsResponse = (stripeAppUpdateSettingsResponseSuccess | stripeAppUpdateSettingsResponseError)

export const getStripeAppUpdateSettingsUrl = () => {


  

  return `/stripe-app/settings`
}

export const stripeAppUpdateSettings = async (stripeAppUpdateSettingsBody: StripeAppUpdateSettingsBody, options?: RequestInit): Promise<stripeAppUpdateSettingsResponse> => {
  
  return customFetch<stripeAppUpdateSettingsResponse>(getStripeAppUpdateSettingsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stripeAppUpdateSettingsBody,)
  }
);}
  

/**
 * Create a Space Invoices invoice from a Stripe object ID. The backend fetches the full object from Stripe API and extracts customer, line items, and tax data.
 * @summary Create invoice from Stripe object
 */
export type stripeAppCreateInvoiceResponse201 = {
  data: StripeAppInvoice
  status: 201
}

export type stripeAppCreateInvoiceResponse400 = {
  data: Error
  status: 400
}

export type stripeAppCreateInvoiceResponse401 = {
  data: Error
  status: 401
}

export type stripeAppCreateInvoiceResponse403 = {
  data: Error
  status: 403
}

export type stripeAppCreateInvoiceResponse404 = {
  data: Error
  status: 404
}

export type stripeAppCreateInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppCreateInvoiceResponse500 = {
  data: Error
  status: 500
}

export type stripeAppCreateInvoiceResponseSuccess = (stripeAppCreateInvoiceResponse201) & {
  headers: Headers;
};
export type stripeAppCreateInvoiceResponseError = (stripeAppCreateInvoiceResponse400 | stripeAppCreateInvoiceResponse401 | stripeAppCreateInvoiceResponse403 | stripeAppCreateInvoiceResponse404 | stripeAppCreateInvoiceResponse422 | stripeAppCreateInvoiceResponse500) & {
  headers: Headers;
};

export type stripeAppCreateInvoiceResponse = (stripeAppCreateInvoiceResponseSuccess | stripeAppCreateInvoiceResponseError)

export const getStripeAppCreateInvoiceUrl = () => {


  

  return `/stripe-app/invoices`
}

export const stripeAppCreateInvoice = async (stripeAppCreateInvoiceBody: StripeAppCreateInvoiceBody, options?: RequestInit): Promise<stripeAppCreateInvoiceResponse> => {
  
  return customFetch<stripeAppCreateInvoiceResponse>(getStripeAppCreateInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stripeAppCreateInvoiceBody,)
  }
);}
  

/**
 * List recent invoices for the connected entity.
 * @summary List invoices
 */
export type stripeAppListInvoicesResponse200 = {
  data: StripeAppInvoiceList
  status: 200
}

export type stripeAppListInvoicesResponse400 = {
  data: Error
  status: 400
}

export type stripeAppListInvoicesResponse401 = {
  data: Error
  status: 401
}

export type stripeAppListInvoicesResponse403 = {
  data: Error
  status: 403
}

export type stripeAppListInvoicesResponse404 = {
  data: Error
  status: 404
}

export type stripeAppListInvoicesResponse500 = {
  data: Error
  status: 500
}

export type stripeAppListInvoicesResponseSuccess = (stripeAppListInvoicesResponse200) & {
  headers: Headers;
};
export type stripeAppListInvoicesResponseError = (stripeAppListInvoicesResponse400 | stripeAppListInvoicesResponse401 | stripeAppListInvoicesResponse403 | stripeAppListInvoicesResponse404 | stripeAppListInvoicesResponse500) & {
  headers: Headers;
};

export type stripeAppListInvoicesResponse = (stripeAppListInvoicesResponseSuccess | stripeAppListInvoicesResponseError)

export const getStripeAppListInvoicesUrl = (params?: StripeAppListInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/stripe-app/invoices?${stringifiedParams}` : `/stripe-app/invoices`
}

export const stripeAppListInvoices = async (params?: StripeAppListInvoicesParams, options?: RequestInit): Promise<stripeAppListInvoicesResponse> => {
  
  return customFetch<stripeAppListInvoicesResponse>(getStripeAppListInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Find an Apollo invoice linked to a Stripe object (invoice or payment intent) via auto-invoicing events.
 * @summary Look up invoice by Stripe object ID
 */
export type stripeAppLookupInvoiceResponse200 = {
  data: StripeAppInvoice
  status: 200
}

export type stripeAppLookupInvoiceResponse400 = {
  data: Error
  status: 400
}

export type stripeAppLookupInvoiceResponse401 = {
  data: Error
  status: 401
}

export type stripeAppLookupInvoiceResponse403 = {
  data: Error
  status: 403
}

export type stripeAppLookupInvoiceResponse404 = {
  data: Error
  status: 404
}

export type stripeAppLookupInvoiceResponse500 = {
  data: Error
  status: 500
}

export type stripeAppLookupInvoiceResponseSuccess = (stripeAppLookupInvoiceResponse200) & {
  headers: Headers;
};
export type stripeAppLookupInvoiceResponseError = (stripeAppLookupInvoiceResponse400 | stripeAppLookupInvoiceResponse401 | stripeAppLookupInvoiceResponse403 | stripeAppLookupInvoiceResponse404 | stripeAppLookupInvoiceResponse500) & {
  headers: Headers;
};

export type stripeAppLookupInvoiceResponse = (stripeAppLookupInvoiceResponseSuccess | stripeAppLookupInvoiceResponseError)

export const getStripeAppLookupInvoiceUrl = (params: StripeAppLookupInvoiceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/stripe-app/invoices/lookup?${stringifiedParams}` : `/stripe-app/invoices/lookup`
}

export const stripeAppLookupInvoice = async (params: StripeAppLookupInvoiceParams, options?: RequestInit): Promise<stripeAppLookupInvoiceResponse> => {
  
  return customFetch<stripeAppLookupInvoiceResponse>(getStripeAppLookupInvoiceUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get a specific invoice with public link and compliance/fiscalization status.
 * @summary Get invoice detail
 */
export type stripeAppGetInvoiceResponse200 = {
  data: StripeAppInvoice
  status: 200
}

export type stripeAppGetInvoiceResponse400 = {
  data: Error
  status: 400
}

export type stripeAppGetInvoiceResponse401 = {
  data: Error
  status: 401
}

export type stripeAppGetInvoiceResponse403 = {
  data: Error
  status: 403
}

export type stripeAppGetInvoiceResponse404 = {
  data: Error
  status: 404
}

export type stripeAppGetInvoiceResponse500 = {
  data: Error
  status: 500
}

export type stripeAppGetInvoiceResponseSuccess = (stripeAppGetInvoiceResponse200) & {
  headers: Headers;
};
export type stripeAppGetInvoiceResponseError = (stripeAppGetInvoiceResponse400 | stripeAppGetInvoiceResponse401 | stripeAppGetInvoiceResponse403 | stripeAppGetInvoiceResponse404 | stripeAppGetInvoiceResponse500) & {
  headers: Headers;
};

export type stripeAppGetInvoiceResponse = (stripeAppGetInvoiceResponseSuccess | stripeAppGetInvoiceResponseError)

export const getStripeAppGetInvoiceUrl = (id: string,) => {


  

  return `/stripe-app/invoices/${id}`
}

export const stripeAppGetInvoice = async (id: string, options?: RequestInit): Promise<stripeAppGetInvoiceResponse> => {
  
  return customFetch<stripeAppGetInvoiceResponse>(getStripeAppGetInvoiceUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get the Stripe App connection status for the current entity. Returns 404 when not connected.
 * @summary Get entity Stripe connection
 */
export type stripeAppEntityGetConnectionResponse200 = {
  data: StripeAppConnection
  status: 200
}

export type stripeAppEntityGetConnectionResponse400 = {
  data: Error
  status: 400
}

export type stripeAppEntityGetConnectionResponse401 = {
  data: Error
  status: 401
}

export type stripeAppEntityGetConnectionResponse403 = {
  data: Error
  status: 403
}

export type stripeAppEntityGetConnectionResponse404 = {
  data: Error
  status: 404
}

export type stripeAppEntityGetConnectionResponse500 = {
  data: Error
  status: 500
}

export type stripeAppEntityGetConnectionResponseSuccess = (stripeAppEntityGetConnectionResponse200) & {
  headers: Headers;
};
export type stripeAppEntityGetConnectionResponseError = (stripeAppEntityGetConnectionResponse400 | stripeAppEntityGetConnectionResponse401 | stripeAppEntityGetConnectionResponse403 | stripeAppEntityGetConnectionResponse404 | stripeAppEntityGetConnectionResponse500) & {
  headers: Headers;
};

export type stripeAppEntityGetConnectionResponse = (stripeAppEntityGetConnectionResponseSuccess | stripeAppEntityGetConnectionResponseError)

export const getStripeAppEntityGetConnectionUrl = () => {


  

  return `/stripe-app/entity-connection`
}

export const stripeAppEntityGetConnection = async ( options?: RequestInit): Promise<stripeAppEntityGetConnectionResponse> => {
  
  return customFetch<stripeAppEntityGetConnectionResponse>(getStripeAppEntityGetConnectionUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Remove the Stripe App connection for the current entity.
 * @summary Disconnect entity Stripe connection
 */
export type stripeAppEntityDisconnectResponse200 = {
  data: StripeAppEntityDisconnect200
  status: 200
}

export type stripeAppEntityDisconnectResponse400 = {
  data: Error
  status: 400
}

export type stripeAppEntityDisconnectResponse401 = {
  data: Error
  status: 401
}

export type stripeAppEntityDisconnectResponse403 = {
  data: Error
  status: 403
}

export type stripeAppEntityDisconnectResponse404 = {
  data: Error
  status: 404
}

export type stripeAppEntityDisconnectResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppEntityDisconnectResponse500 = {
  data: Error
  status: 500
}

export type stripeAppEntityDisconnectResponseSuccess = (stripeAppEntityDisconnectResponse200) & {
  headers: Headers;
};
export type stripeAppEntityDisconnectResponseError = (stripeAppEntityDisconnectResponse400 | stripeAppEntityDisconnectResponse401 | stripeAppEntityDisconnectResponse403 | stripeAppEntityDisconnectResponse404 | stripeAppEntityDisconnectResponse422 | stripeAppEntityDisconnectResponse500) & {
  headers: Headers;
};

export type stripeAppEntityDisconnectResponse = (stripeAppEntityDisconnectResponseSuccess | stripeAppEntityDisconnectResponseError)

export const getStripeAppEntityDisconnectUrl = () => {


  

  return `/stripe-app/entity-connection`
}

export const stripeAppEntityDisconnect = async ( options?: RequestInit): Promise<stripeAppEntityDisconnectResponse> => {
  
  return customFetch<stripeAppEntityDisconnectResponse>(getStripeAppEntityDisconnectUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Get auto-invoice settings for the current entity's Stripe App connection.
 * @summary Get entity Stripe settings
 */
export type stripeAppEntityGetSettingsResponse200 = {
  data: StripeAppSettings
  status: 200
}

export type stripeAppEntityGetSettingsResponse400 = {
  data: Error
  status: 400
}

export type stripeAppEntityGetSettingsResponse401 = {
  data: Error
  status: 401
}

export type stripeAppEntityGetSettingsResponse403 = {
  data: Error
  status: 403
}

export type stripeAppEntityGetSettingsResponse404 = {
  data: Error
  status: 404
}

export type stripeAppEntityGetSettingsResponse500 = {
  data: Error
  status: 500
}

export type stripeAppEntityGetSettingsResponseSuccess = (stripeAppEntityGetSettingsResponse200) & {
  headers: Headers;
};
export type stripeAppEntityGetSettingsResponseError = (stripeAppEntityGetSettingsResponse400 | stripeAppEntityGetSettingsResponse401 | stripeAppEntityGetSettingsResponse403 | stripeAppEntityGetSettingsResponse404 | stripeAppEntityGetSettingsResponse500) & {
  headers: Headers;
};

export type stripeAppEntityGetSettingsResponse = (stripeAppEntityGetSettingsResponseSuccess | stripeAppEntityGetSettingsResponseError)

export const getStripeAppEntityGetSettingsUrl = () => {


  

  return `/stripe-app/entity-settings`
}

export const stripeAppEntityGetSettings = async ( options?: RequestInit): Promise<stripeAppEntityGetSettingsResponse> => {
  
  return customFetch<stripeAppEntityGetSettingsResponse>(getStripeAppEntityGetSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update auto-invoice settings for the current entity's Stripe App connection.
 * @summary Update entity Stripe settings
 */
export type stripeAppEntityUpdateSettingsResponse200 = {
  data: StripeAppSettings
  status: 200
}

export type stripeAppEntityUpdateSettingsResponse400 = {
  data: Error
  status: 400
}

export type stripeAppEntityUpdateSettingsResponse401 = {
  data: Error
  status: 401
}

export type stripeAppEntityUpdateSettingsResponse403 = {
  data: Error
  status: 403
}

export type stripeAppEntityUpdateSettingsResponse404 = {
  data: Error
  status: 404
}

export type stripeAppEntityUpdateSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type stripeAppEntityUpdateSettingsResponse500 = {
  data: Error
  status: 500
}

export type stripeAppEntityUpdateSettingsResponseSuccess = (stripeAppEntityUpdateSettingsResponse200) & {
  headers: Headers;
};
export type stripeAppEntityUpdateSettingsResponseError = (stripeAppEntityUpdateSettingsResponse400 | stripeAppEntityUpdateSettingsResponse401 | stripeAppEntityUpdateSettingsResponse403 | stripeAppEntityUpdateSettingsResponse404 | stripeAppEntityUpdateSettingsResponse422 | stripeAppEntityUpdateSettingsResponse500) & {
  headers: Headers;
};

export type stripeAppEntityUpdateSettingsResponse = (stripeAppEntityUpdateSettingsResponseSuccess | stripeAppEntityUpdateSettingsResponseError)

export const getStripeAppEntityUpdateSettingsUrl = () => {


  

  return `/stripe-app/entity-settings`
}

export const stripeAppEntityUpdateSettings = async (stripeAppEntityUpdateSettingsBody: StripeAppEntityUpdateSettingsBody, options?: RequestInit): Promise<stripeAppEntityUpdateSettingsResponse> => {
  
  return customFetch<stripeAppEntityUpdateSettingsResponse>(getStripeAppEntityUpdateSettingsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stripeAppEntityUpdateSettingsBody,)
  }
);}
  

